import api from "@/lib/api";

// Persistent anonymous id so anonymous views de-dupe per person per day (server-side).
function anonId() {
  try {
    let id = localStorage.getItem("cbr_anon_id");
    if (!id) {
      id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("cbr_anon_id", id);
    }
    return id;
  } catch (_) {
    return undefined;
  }
}

// Fire-and-forget engagement tracking. Never throws, never blocks the UI.
export function track(eventType, playerId, source = "", meta = {}) {
  if (!eventType || !playerId) return;
  try {
    api.post("/analytics/track", {
      event_type: eventType,
      player_id: playerId,
      session_id: anonId(),
      source,
      meta,
    }).catch(() => {});
  } catch (_) {
    /* noop */
  }
}
